var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.5C5.2 1.5 1 5.4 1 10C1 12.6 2.3 15 4.4 16.5C3.6 17.9 2.7 19 1.8 19.9C1.8 19.9 1.7 20 1.7 20.1C1.7 20.2 1.7 20.4 1.7 20.5C1.7 20.6 1.8 20.7 1.8 20.8C2.6 21 3.6 21.1 4.6 20.9C6.5 20.5 8 19.5 9.1 18.4C9.5 18.5 10 18.5 10.5 18.5C15.8 18.5 20 14.6 20 10C20 5.4 15.8 1.5 10.5 1.5Z",
    stroke: "#40D9B5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBubble);
export default __webpack_public_path__ + "static/media/message-bubble.8b0a2436ed26a811f6f45033d9eb6952.svg";
export { ForwardRef as ReactComponent };